import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, throwError } from 'rxjs';
import { AuthService } from '@/app/core/auth/auth.service';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    if (isPublicRequest(req)) {
        return next(req);
    }

    const auth = inject(AuthService);
    const router = inject(Router);
    const token = auth.getAccessToken();
    const outgoing = token ? withAuthHeaders(req, token) : req;

    return next(outgoing).pipe(
        catchError((error: unknown) => {
            if (error instanceof HttpErrorResponse && error.status === 401) {
                auth.logout();
                if (!router.url.startsWith('/auth/login')) {
                    void router.navigate(['/auth/login'], {
                        queryParams: { returnUrl: router.url }
                    });
                }
            }
            return throwError(() => error);
        })
    );
};

function isPublicRequest(req: HttpRequest<unknown>): boolean {
    return req.url.includes('/auth/token') || req.url.includes('/auth/social/') || req.url.includes('/i18n/');
}

function withAuthHeaders(req: HttpRequest<unknown>, token: string): HttpRequest<unknown> {
    const isFormData = typeof FormData !== 'undefined' && req.body instanceof FormData;
    const headers: Record<string, string> = {
        Authorization: `Bearer ${token}`
    };
    if (!req.headers.has('Accept')) {
        headers['Accept'] = 'application/json';
    }
    if (!isFormData) {
        headers['Content-Type'] = 'application/json';
    }
    return req.clone({ setHeaders: headers });
}
